import { FC } from 'react'

interface CarouselDotsProps {
  total: number
  active: number
  onDotClick: (index: number) => void
}

const CarouselDots: FC<CarouselDotsProps> = ({ total, active, onDotClick }) => {
  return (
    <div className="flex justify-center space-x-2 mt-4">
      {Array.from({ length: total }).map((_, i) => (
        <button
          key={i}
          onClick={() => onDotClick(i)}
          className={`w-2 h-2 rounded-full transition-colors ${
            i === active ? 'bg-black' : 'bg-gray-300'
          }`}
        />
      ))}
    </div>
  )
}

export default CarouselDots 